import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { AwsTrackingService } from './common/tracking/aws-tracking.service';
import { AwsTracker, Level } from './common/tracking/aws-tracker';
import { LocationStrategy } from '@angular/common';
import { ChatService } from './common/chat/chat.service';
import { ApplicationService } from './application/application.service';
import { TokenService } from './token/token.service';
import { LoginService } from 'app/login/login.service';
import * as Sentry from '@sentry/browser';
import { Channel } from './channel.service';
declare var $: any;
declare var window: any;

@Component({
  selector: 'zest-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  private windowTracker: AwsTracker;

  constructor(private router: Router, private locationStrategy: LocationStrategy, private tokenService: TokenService, private applicationService: ApplicationService, private awsTrackingService: AwsTrackingService, private chatService: ChatService, private loginService: LoginService) {
    const bases = document.getElementsByTagName('base');

    if (bases.length > 0) {
      bases[0].setAttribute('href', environment.baseHref);
    }
    this.router.events.subscribe(() => {
      window.focus();
    });
  }
  ngOnInit() {
    // this.addCss();
    if (window.BroadcastChannel) {
      const tokenchannel = Channel.getChannelObj();
      tokenchannel.subscribeChannel((e) => {
        if ((e.data.type === 'Authentication') && (e.data.value !== this.tokenService.getCustomerContact())) {
        this.tokenService.logout();
        }
      });
    }
    const fkPlatform = window.FKExtension && window.FKExtension.isPlatformAvailable() ? true : false;
    this.tokenService.setFlipkartUltra(fkPlatform);
    const customerId = this.tokenService.getCustomerId();
    if (customerId) {
      Sentry.configureScope((scope) => {
        scope.setUser({'id': customerId});
      });
    }
    if (window.self === window.top && window.top.location.href !== window.location.href) {
      window.top.location.href = window.location.href;
      $('html').css('background-color', 'white');
    }
    const merchantName = this.tokenService.getMerchantConfig() ? this.tokenService.getMerchantConfig().merchantName : null;
    const merchant = merchantName ? merchantName.replace(/\s/g, '').toLowerCase() : null;
    if (environment.customThemeMerchants.includes(merchant)) {
      this.setTheme(merchant);
    } else {
      document.documentElement.removeAttribute('style');
    }
    window.addEventListener('focus', () => {
      if (this.windowTracker) {
        this.windowTracker.Value = this.locationStrategy.getBaseHref() + '_Page Level';
        if (customerId) {
          this.awsTrackingService.sendData(this.windowTracker, this.applicationService.getApplicationId(), customerId).subscribe();
        } else {
          this.awsTrackingService.sendData(this.windowTracker, this.applicationService.getApplicationId()).subscribe();
        }
      }
    });
    window.addEventListener('blur', () => {
      this.windowTracker = new AwsTracker(Level.Window, 'Blurred');
    });
    this.chatService.getData();
    this.receiveMsgFromMyAcounts();
    if ( this.loginService.inIframe() ) {
      this.turnOffChat();
    }
    this.getDatafromWidget();
    this.initShield();
  }
  resolveShieldScript() {
    const resolver = new Promise((resolve, reject) => {
      let tryCount = 0;
      const interval = window.setInterval(() => {
        tryCount = tryCount + 1;
        if (window.getDeviceResult) {
          window.clearInterval(interval);
          resolve(window.getDeviceResult);
        }
        if (tryCount > 10) {
          reject(window.getDeviceResult);
        }
      }, 1000);
    });
    return resolver;
  }
  initShield() {
    this.applicationService.sendDataToLogger(`Before SHIELD invocation`, {
      path: '/authentication',
      errorMessage: 'NA'
    }, 'INFO').subscribe();
    this.resolveShieldScript().then((getDeviceResult = () => {}) => {
      this.applicationService.sendDataToLogger(`SHIELD invocation success`, {
        path: '/authentication',
        errorMessage: 'NA',
        error: typeof getDeviceResult
      }, 'INFO').subscribe();
      if (typeof getDeviceResult === 'function') {
        getDeviceResult().then((res) => {
          // INIT SHIELD ON APP LOAD
          this.applicationService.sendDataToLogger(`SHIELD Data Logged : ${res.result.session_id}`, {
            path: '/authentication',
            errorMessage: 'NA',
            error: res.result
          }, 'INFO').subscribe();
          this.tokenService.setShieldData(res.result);
        }).catch((error) => {
          this.applicationService.sendDataToLogger(`SHIELD getDeviceResult error`, {
            path: '/authentication',
            errorMessage: 'NA',
            error: error.message
          }, 'INFO').subscribe();
        });
      }
    }).catch((error) => {
      this.applicationService.sendDataToLogger(`SHIELD invocation error`, {
        path: '/authentication',
        errorMessage: 'NA',
        error: error.message
      }, 'INFO').subscribe();
    });
  }
  getDatafromWidget() {
    if (!window.parent) {
        return;
    }
    if (this.tokenService.getDatafromPartnerSession) {
      this.tokenService.removeDatafromPartnerSession();
    }
    const messageHandler = (e) => {
    if (environment.partnerCheckoutUrl.includes(e.origin)) {
        this.tokenService.recieveDatafromPartner(e.data);
      }
    };
    window.addEventListener('message', messageHandler, false);
    let intervalCounter = 0;
    const interval = setInterval(() => {
      const dataAcknowledgement = this.tokenService.getDatafromPartnerSession();
      if (dataAcknowledgement) {
        this.awsTrackingService.gtmPageLoadEvent('Authentication-Started');
        clearInterval(interval);
      } else {
        intervalCounter++;
      }
      if (intervalCounter === 10) {
        intervalCounter = 0;
        clearInterval(interval);
      }
    }, 300);
  }

  setTheme(merchant) {
    this.applicationService.getMerchantThemeVariables(merchant).subscribe(res => {
      for (const cssVar in res) {
        if (res) {
          document.documentElement.style.setProperty(cssVar, res[cssVar]);
        }
      }
    });
  }
  addCss() {
    if (environment.production || environment.type === 'Staging' || environment.type === 'Test') {
      const element = document.createElement('link');
      element.rel = 'stylesheet';
      element.href = 'lazy-global-style.css?v=' + (new Date()).getTime();
      const firstLinkTag = document.getElementsByTagName('link')[0];
      firstLinkTag.appendChild(element);
    } else {
      const element = document.createElement('script');
      element.src = 'lazy-global-style.js';
      document.body.appendChild(element);
    }
  }
  receiveMsgFromMyAcounts() {
    const messageHandler = (e) => {
      if (e.origin !== environment.youraccountUrl) {
        return;
      }
      const receiveMsg = e.data.split(/:(.+)/);
      const action = receiveMsg[0];
      const data = JSON.parse(receiveMsg[1]);
      switch (action) {
        case 'token': {
          this.tokenService.saveToSession(data);
          // this.tokenService.setMixPanelUserId();
          break;
        }
        case 'application': {
          this.tokenService.clearMerchantData();
          this.applicationService.saveApplication(data);
          break;
        }
        case 'zest-setup-repayments-feature': {
          this.tokenService.setRedirectToRepaymentsFeaturePage(data);
          break;
        }
        case 'zest-myaccounts-repayments-setup': {
          this.tokenService.setRepaymentsSetupFromMyAccounts(data);
          break;
        }
        case 'zest-myaccounts-bank-details-setup': {
          this.tokenService.setBDFromMyAccounts(data);
          break;
        }
        case 'zest-kyc-verification-feature': {
          this.tokenService.setKYCVerificationFromMyAccounts(data);
          break;
        }
        case 'zest-validations': {
          this.tokenService.setLinkValidations(data);
          break;
        }
        case 'zest-bolt-customer': {
          this.tokenService.setRedirectToBoltPage(data);
          break;
        }
        default: break;
      }
      e.source.postMessage(action + 'Received', e.origin);
    };
    window.addEventListener('message', messageHandler, false);
  }
  turnOffChat() {
    if (window.olark) {
      window.olark('api.box.hide');
    }
    if (window.ymConfig) {
      document.body.className += 'hide-chat-icon';
    }
  }
}
